import React from "react";

export default () => <li role="separator" className="divider"/>;
